/** Convert spherical.computeArea (m²) to sq ft */
export const SQ_METERS_TO_SQ_FT = 10.76391041671;

export function sqMetersToSqft(sqMeters) {
  if (!Number.isFinite(sqMeters) || sqMeters <= 0) return 0;
  return Math.round(sqMeters * SQ_METERS_TO_SQ_FT);
}
